import { render, staticRenderFns } from "./Constitution.vue?vue&type=template&id=d20a3eb6&scoped=true&"
import script from "./Constitution.vue?vue&type=script&lang=js&"
export * from "./Constitution.vue?vue&type=script&lang=js&"
import style0 from "./Constitution.vue?vue&type=style&index=0&id=d20a3eb6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d20a3eb6",
  null
  
)

export default component.exports